// 创建一个高亮搜索的工具函数

// 对正则特殊字符进行转义，但保留常用搜索字符如 - 和 _
const escapeRegExp = (string) => {
  // 只转义真正需要转义的特殊字符，不包括 - 和 _
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

// 排除 fieldType 为 8、9、10、26、27 的情况
const excludeTypes = ['8', '9', '10', '26', '27'];

const exactMatchType = ['7', '16', '23']; //金额、数字、百分比

const useTableSearch = () => {
  // 全局高亮处理函数
  function highlightText(keyword, searchFieldsList, fieldShowRef) {
    if (!keyword) return;

    const pattern = escapeRegExp(keyword);

    // 通过传入的DOM元素找到父级容器，然后在其中搜索表格单元格
    const parentContainer = fieldShowRef?.closest('.qf-table-body');
    if (!parentContainer) return;

    const cells = parentContainer.querySelectorAll('.qf-table-cell');

    cells.forEach((cell) => {
      // 先检查 field type 和 field key
      const compFieldMain = cell.querySelector('.comp-field-main');
      const fieldType = compFieldMain?.getAttribute('data-field-type');
      const fieldKey = compFieldMain?.getAttribute('data-field-key');
      const fieldValue = compFieldMain?.getAttribute('data-field-value');

      const shouldHighlight = fieldType && !excludeTypes.includes(fieldType);
      const matchesSearchField = !searchFieldsList?.length || searchFieldsList.includes(fieldKey);

      const isExactMatch = exactMatchType.includes(fieldType);

      // 只有当字段类型和字段key都符合条件时，才进行文本匹配
      if (shouldHighlight && matchesSearchField) {
        // 获取当前单元格中所有的 ellipsis-content 元素
        const ellipsisContents = cell.querySelectorAll('.ellipsis-content');

        // 遍历每个 ellipsis-content 元素
        ellipsisContents.forEach((ellipsisContent) => {
          const originalText = ellipsisContent.textContent;

          let isMatched = false;

          if (isExactMatch && fieldValue !== null) {
            // 对于数值类型，进行数值比较
            const searchValue = parseFloat(keyword.replace(/,/g, '')); // 移除可能的千分位逗号
            const cellValue = parseFloat(fieldValue);

            // 检查是否都是有效数字且相等
            if (!isNaN(searchValue) && !isNaN(cellValue)) {
              isMatched = Math.abs(searchValue - cellValue) < 0.000001; // 使用极小值比较防止浮点数精度问题
            }
          } else {
            // 非数值类型使用正则匹配
            const regex = new RegExp(pattern, 'gi');
            regex.lastIndex = 0;
            isMatched = regex.test(originalText);
          }

          if (isMatched) {
            // 找到匹配的文本，添加背景色
            cell.classList.add('highlight-cell');

            // 保留原始文本，防止多次替换叠加
            ellipsisContent.setAttribute('data-original', originalText);

            // 对于数值类型直接高亮整个内容，对于其他类型高亮匹配部分
            const highlighted = isExactMatch ? `<mark class="highlight">${originalText}</mark>` : originalText.replace(new RegExp(pattern, 'gi'), (match) => `<mark class="highlight">${match}</mark>`);

            // 更新 DOM
            ellipsisContent.innerHTML = highlighted;
          }
        });
      }
    });
  }

  // 局部高亮处理函数
  function highlightTextLocal(keyword, fieldShowRef, fieldShowInfo) {
    if (!keyword) return;
    console.log('局部更新333', keyword, fieldShowRef, fieldShowInfo);

    const ellipsisContents = fieldShowRef?.querySelectorAll('.ellipsis-content'); //拿到当前单元格的ellipsis-content
    if (!ellipsisContents?.length) return; //确保dom渲染完成
    const fieldType = fieldShowInfo?.fieldType;
    const fieldValue = fieldShowInfo?.fieldValue;

    const isExactMatch = exactMatchType.includes(fieldType);

    if (fieldType && excludeTypes.includes(fieldType)) return;

    ellipsisContents.forEach((ellipsisContent) => {
      let isMatched = false;
      const pattern = escapeRegExp(keyword);
      const originalText = ellipsisContent.textContent;

      if (isExactMatch && fieldValue !== null) {
        // 对于数值类型，进行数值比较
        const searchValue = parseFloat(keyword.replace(/,/g, '')); // 移除可能的千分位逗号
        const cellValue = parseFloat(fieldValue);

        // 检查是否都是有效数字且相等
        if (!isNaN(searchValue) && !isNaN(cellValue)) {
          isMatched = Math.abs(searchValue - cellValue) < 0.000001; // 使用极小值比较防止浮点数精度问题
        }
      } else {
        // 非数值类型使用正则匹配
        const regex = new RegExp(pattern, 'gi');
        isMatched = regex.test(originalText);
      }

      if (isMatched) {
        // 对于数值类型直接高亮整个内容，对于其他类型高亮匹配部分
        const highlighted = isExactMatch ? `<mark class="highlight">${originalText}</mark>` : originalText.replace(new RegExp(pattern, 'gi'), (match) => `<mark class="highlight">${match}</mark>`);
        ellipsisContent.innerHTML = highlighted;
      }
    });
  }

  // 清除高亮
  const clearHighlight = () => {
    // 清除文本高亮
    const elements = document.querySelectorAll('.qf-table-body .ellipsis-content');
    elements.forEach((el) => {
      // 如果有原始文本，则恢复
      const originalText = el.getAttribute('data-original');
      if (originalText) {
        el.innerHTML = originalText;
        el.removeAttribute('data-original');
      }
    });

    // 清除单元格背景色
    const highlightCells = document.querySelectorAll('.highlight-cell');
    highlightCells.forEach((cell) => {
      cell.classList.remove('highlight-cell');
    });
  };

  return {
    highlightText,
    clearHighlight,
    highlightTextLocal
  };
};

export default useTableSearch;
